import { Link } from "wouter";
import { SUPPORT_EMAIL, SUPPORT_MAILTO, STATUS_PAGE_URL } from "@/lib/support";

/**
 * Slim footer rendered inside the authenticated app shell. Surfaces the
 * support inbox, the public status page, and the legal/security pages so
 * customers can always find them without leaving the app.
 */
export function AppFooter() {
  return (
    <footer className="mt-auto border-t bg-background/60 px-4 sm:px-6 py-3">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} Zebiso Intelligence, Inc.</span>
        <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <a href={SUPPORT_MAILTO} className="hover:text-foreground transition-colors">
            Support ({SUPPORT_EMAIL})
          </a>
          <a
            href={STATUS_PAGE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            Status
          </a>
          <Link href="/security" className="hover:text-foreground transition-colors">
            Security
          </Link>
          <Link href="/terms" className="hover:text-foreground transition-colors">
            Terms
          </Link>
          <Link href="/privacy" className="hover:text-foreground transition-colors">
            Privacy
          </Link>
          <Link href="/subprocessors" className="hover:text-foreground transition-colors">
            Subprocessors
          </Link>
        </nav>
      </div>
    </footer>
  );
}
